<!-- ONE VEHICLE CARD -->
<div>
  <div class="row">
    <div class="col-xl-3-custom col-lg-4 col-md-6 col-sm-12" *ngFor="let vehicle of vehicles; let index = index">
      <div class="card">
        <div class="ribbon" *ngIf="vehicle.vehicleInfo.importStatus === importStatus.COMPLETED">
          <span class="imported-badge" translate>vehicles.imported</span>
        </div>
        <div class="ribbon" *ngIf="vehicle.vehicleInfo.importStatus === importStatus.NOT_AVAILABLE">
          <span class="imported-badge" translate>vehicles.notAvailable</span>
        </div>
        <div *ngIf="[vehicleStatus.PROCESSING, vehicleStatus.PENDING, vehicleStatus.QC].includes(vehicle.vehicleInfo.status)"
          class="processing-layer">
          <div class="logo"></div>
          <div class="flex">
            <p *ngIf="vehicle.vehicleInfo.status === vehicleStatus.PROCESSING || vehicle.vehicleInfo.status === vehicleStatus.PENDING"
              translate [translateParams]="{count: vehicle.vehicleInfo.processing}">vehicles.processingInfo</p>
            <p *ngIf="vehicle.vehicleInfo.status === vehicleStatus.QC" translate
              [translateParams]="{count: vehicle.vehicleInfo.processing}">vehicles.vehicleOnQC</p>
            <div *ngIf="user.role.name === 'root' && vehicle.vehicleInfo.status === vehicleStatus.PROCESSING"
              class="processing-actions" (click)="$event.stopPropagation()">
              <button class="status-action complete" (click)="changeVehicleStatus(vehicle, vehicleStatus.COMPLETED)">
                ✓ Complete
              </button>

              <button class="status-action failed" (click)="changeVehicleStatus(vehicle, vehicleStatus.FAILED)">
                ✕ Fail
              </button>
            </div>
          </div>
          <div *ngIf="isVisibleRefresh()" class="refresh" (click)="reloadVehicles()"></div>
        </div>
        <div *ngIf="[importStatus.IMPORTING , importStatus.PENDING].includes(vehicle.vehicleInfo.importStatus)" class="processing-layer">
          <div class="logo"></div>
          <p *ngIf="vehicle.vehicleInfo.importStatus === importStatus.PENDING"
            translate [translateParams]="{count: vehicle.vehicleInfo.processing}">Pending import</p>
          <p *ngIf="vehicle.vehicleInfo.importStatus === importStatus.IMPORTING" translate
            [translateParams]="{count: vehicle.vehicleInfo.processing}" translate>vehicles.importingImages</p>
          <div *ngIf="isVisibleRefresh()" class="refresh" (click)="reloadVehicles()"></div>
        </div>
        <div *ngIf="isVisible() && vehicle.user" class="card-username">
          {{vehicle.user.name}}
        </div>
        <div *ngIf="user.role.name === 'root' && vehicle.user" class="card-username">
          Email: {{vehicle.user.email}}
        </div>
        <div *ngIf="user.role.name === 'root' && vehicle.user && vehicle.user.client" class="card-username">
          Client: {{vehicle.user.client.name}}
        </div>
        <div *ngIf="user.role.name === 'root' && vehicle.user && vehicle.user.customer" class="card-username">
          Customer: {{vehicle.user.customer.name}}
        </div>
        <div class="top" (click)="navigateToVehicle(vehicle)">
          <div class="vehicle-image" [style.background-image]="(vehicle.previewPicture != null) ? 
                      'url(' + vehicle.previewPicture + ')' : 'url(assets/img/no-image.png)'"
            [class.default]="!(vehicle?.previewPicture != null)">
            <video *ngIf="vehicle.previewPicture?.includes('.mp4', '.mov')" class="video-player">
              <source src="{{vehicle.previewPicture}}" type="video/mp4" />
              Browser not supported
             </video>
          </div>

          <div class="topright">
            <div class="text-row text-vin">{{vehicle.vehicleInfo.vin}}</div>
            <div class="text-row text-vin" 
              style="align-items: center; display: flex; justify-content: center;" 
              *ngIf="vehicle.vehicleInfo.licensePlateNumber"><img src="../../../../assets/img/plate.svg" /> <span style="font-weight: bold;">{{vehicle.vehicleInfo.licensePlateNumber}}</span></div>
            <div class="text-row text-vin" *ngIf="vehicle.vehicleInfo.condition"> <i class="fa fa-car"></i> <span style="font-weight: bold;">{{vehicle.vehicleInfo.condition === 'used' ? ' Used vehicle' : ' New vehicle'}}</span></div>
            <ng-container *ngIf="vehicle.vehicleInfo.copyVehicleId">
              <div class="text-row text-vin">Preset: {{vehicle.vehicleInfo?.preset?.name}}</div>
              <div class="text-row text-vin">Profile: {{vehicle.vehicleInfo?.profile?.name || 'Default'}}</div>
            </ng-container>
            <hr class="text-hr">
            <div class="text-row">{{vehicle.vehicleInfo.createdAt | date:'dd.MM.yyyy HH:mm' }}</div>
            <div class="is_uploaded" *ngIf="vehicle.vehicleInfo.isUploaded">
              <p translate>vehicles.uploadedSuccessfully</p>
              <i class="fa fa-check"></i>
            </div>
            <div class="vehicle_details d-flex align-items-center">
              <button *ngIf="isFeatureIncluded(vehicle?.vehicleInfo?.features, ['instagram', 'instagramCatch'])"
                class="btn spec-btn" (click)="$event.stopPropagation(); onVehicleSpecifications(vehicle)">
                S
              </button>
              <div class="more_info" (click)="$event.stopPropagation(); onVehicleDetails(vehicle)">
                <span translate>vehicles.moreInfo<i class="fa fa-info-circle ml-1"></i>
                </span>
              </div>
            </div>
            
          </div>
        </div>
        <!-- <div class="is_uploaded" *ngIf="vehicle.vehicleInfo.isUploaded">
          <p translate>vehicles.uploadedSuccessfully</p>
          <i class="fa fa-check"></i>
        </div> -->
        <div class="bottom">
          <div class="bottom-item bottom-item-exterior"
            [class.bottom-item-exterior-active]="countExterior(vehicle) > 0">{{countExterior(vehicle)}}</div>
          <div class="bottom-item bottom-item-interior"
            [class.bottom-item-interior-active]="countInterior(vehicle) > 0">{{countInterior(vehicle)}}</div>
          <div class="bottom-item bottom-item-details" [class.bottom-item-details-active]="countDetails(vehicle) > 0">
            {{countDetails(vehicle)}}</div>
          <div class="bottom-item bottom-item-video" [class.bottom-item-video-active]="countVideo(vehicle) > 0">
            {{countVideo(vehicle)}}</div>  
        </div>

        <div class="address" *ngIf="vehicle.vehicleInfo.geoLocation?.address && user.role.name !== 'root'">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="none">
            <path
              d="M7.5001 24.5833C5.36538 24.5833 3.62336 24.2712 2.27406 23.6469C0.92475 23.0226 0.250098 22.2271 0.250098 21.2604C0.250098 20.7167 0.496799 20.2031 0.990202 19.7198C1.4836 19.2365 2.16329 18.8438 3.02926 18.5417L3.57301 20.2938C3.25079 20.3944 2.95374 20.5354 2.68187 20.7167C2.40999 20.8979 2.1935 21.0792 2.03239 21.2604C2.37475 21.6632 3.08465 22.0156 4.16208 22.3177C5.23951 22.6198 6.35218 22.7708 7.5001 22.7708C8.64801 22.7708 9.76572 22.6198 10.8532 22.3177C11.9407 22.0156 12.6557 21.6632 12.998 21.2604C12.8369 21.0993 12.6254 20.9281 12.3636 20.7469C12.1018 20.5656 11.7998 20.4146 11.4574 20.2938L11.9709 18.5417C12.8369 18.8438 13.5166 19.2365 14.01 19.7198C14.5034 20.2031 14.7501 20.7167 14.7501 21.2604C14.7501 22.2271 14.0754 23.0226 12.7261 23.6469C11.3768 24.2712 9.63482 24.5833 7.5001 24.5833ZM7.5001 21.3813C7.25843 21.3813 7.04697 21.3108 6.86572 21.1698C6.68447 21.0288 6.55357 20.8476 6.47301 20.626C5.98968 19.1559 5.38551 17.9375 4.66051 16.9708C3.93551 16.0042 3.23065 15.0778 2.54593 14.1917C1.86121 13.3056 1.27718 12.3842 0.793848 11.4276C0.310514 10.471 0.0688477 9.27778 0.0688477 7.84792C0.0688477 5.77362 0.788813 4.0165 2.22874 2.57657C3.66867 1.13664 5.42579 0.416672 7.5001 0.416672C9.5744 0.416672 11.3315 1.13664 12.7715 2.57657C14.2114 4.0165 14.9313 5.77362 14.9313 7.84792C14.9313 9.27778 14.6897 10.471 14.2063 11.4276C13.723 12.3842 13.139 13.3056 12.4543 14.1917C11.7695 15.0778 11.0647 16.0042 10.3397 16.9708C9.61468 17.9375 9.01051 19.1559 8.52718 20.626C8.44662 20.8476 8.31572 21.0288 8.13447 21.1698C7.95322 21.3108 7.74176 21.3813 7.5001 21.3813ZM7.5001 9.66042C8.00357 9.66042 8.43152 9.48421 8.78395 9.13178C9.13638 8.77935 9.3126 8.35139 9.3126 7.84792C9.3126 7.34445 9.13638 6.9165 8.78395 6.56407C8.43152 6.21164 8.00357 6.03542 7.5001 6.03542C6.99663 6.03542 6.56867 6.21164 6.21624 6.56407C5.86381 6.9165 5.6876 7.34445 5.6876 7.84792C5.6876 8.35139 5.86381 8.77935 6.21624 9.13178C6.56867 9.48421 6.99663 9.66042 7.5001 9.66042Z"
              fill="#ff0944" />
          </svg> 
          <p>{{vehicle.vehicleInfo.geoLocation?.address}}</p>

        </div>

        <div class="address" *ngIf="vehicle.user?.customer?.geoLocationEnabled && !vehicle.vehicleInfo.geoLocation?.address && user.role.name !== 'root'">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="none">
            <path
              d="M7.5001 24.5833C5.36538 24.5833 3.62336 24.2712 2.27406 23.6469C0.92475 23.0226 0.250098 22.2271 0.250098 21.2604C0.250098 20.7167 0.496799 20.2031 0.990202 19.7198C1.4836 19.2365 2.16329 18.8438 3.02926 18.5417L3.57301 20.2938C3.25079 20.3944 2.95374 20.5354 2.68187 20.7167C2.40999 20.8979 2.1935 21.0792 2.03239 21.2604C2.37475 21.6632 3.08465 22.0156 4.16208 22.3177C5.23951 22.6198 6.35218 22.7708 7.5001 22.7708C8.64801 22.7708 9.76572 22.6198 10.8532 22.3177C11.9407 22.0156 12.6557 21.6632 12.998 21.2604C12.8369 21.0993 12.6254 20.9281 12.3636 20.7469C12.1018 20.5656 11.7998 20.4146 11.4574 20.2938L11.9709 18.5417C12.8369 18.8438 13.5166 19.2365 14.01 19.7198C14.5034 20.2031 14.7501 20.7167 14.7501 21.2604C14.7501 22.2271 14.0754 23.0226 12.7261 23.6469C11.3768 24.2712 9.63482 24.5833 7.5001 24.5833ZM7.5001 21.3813C7.25843 21.3813 7.04697 21.3108 6.86572 21.1698C6.68447 21.0288 6.55357 20.8476 6.47301 20.626C5.98968 19.1559 5.38551 17.9375 4.66051 16.9708C3.93551 16.0042 3.23065 15.0778 2.54593 14.1917C1.86121 13.3056 1.27718 12.3842 0.793848 11.4276C0.310514 10.471 0.0688477 9.27778 0.0688477 7.84792C0.0688477 5.77362 0.788813 4.0165 2.22874 2.57657C3.66867 1.13664 5.42579 0.416672 7.5001 0.416672C9.5744 0.416672 11.3315 1.13664 12.7715 2.57657C14.2114 4.0165 14.9313 5.77362 14.9313 7.84792C14.9313 9.27778 14.6897 10.471 14.2063 11.4276C13.723 12.3842 13.139 13.3056 12.4543 14.1917C11.7695 15.0778 11.0647 16.0042 10.3397 16.9708C9.61468 17.9375 9.01051 19.1559 8.52718 20.626C8.44662 20.8476 8.31572 21.0288 8.13447 21.1698C7.95322 21.3108 7.74176 21.3813 7.5001 21.3813ZM7.5001 9.66042C8.00357 9.66042 8.43152 9.48421 8.78395 9.13178C9.13638 8.77935 9.3126 8.35139 9.3126 7.84792C9.3126 7.34445 9.13638 6.9165 8.78395 6.56407C8.43152 6.21164 8.00357 6.03542 7.5001 6.03542C6.99663 6.03542 6.56867 6.21164 6.21624 6.56407C5.86381 6.9165 5.6876 7.34445 5.6876 7.84792C5.6876 8.35139 5.86381 8.77935 6.21624 9.13178C6.56867 9.48421 6.99663 9.66042 7.5001 9.66042Z"
              fill="#9A9595" />
            </svg>
  
            <p class="disabled" *ngIf="!vehicle.vehicleInfo.geoLocation?.address" translate>vehicles.noLocationInfo</p>
        </div>
 

        <ngb-accordion [destroyOnHide]='false' [closeOthers]="true" class="features-accordion">
          <ngb-panel [disabled]='vehicle.vehicleInfo.features.length === 0'>
            <ng-template ngbPanelTitle disabled="true">
              <div class="d-flex justify-content-between">
                <div class="d-flex" translate [translateParams]="{number: vehicle.vehicleInfo.features.length}">vehicles.vehicleFeatures</div>
                <div class="d-flex"><i class="fa fa-angle-down"></i></div>
              </div>
            </ng-template>
        
            <ng-template ngbPanelContent *ngIf="vehicle.vehicleInfo.features.length > 0" disabled="true">
              <div class="icons-box">
                <div *ngFor="let feature of vehicle.vehicleInfo.features">
                  <div *ngFor="let icon of featuresIcons">
                    <img *ngIf="feature === icon.name" [src]="icon.icon" [alt]="icon.name" />
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>

      </div>
    </div>
  </div>
</div>

<app-modal (close)="toggleVehicleDetails = false" *ngIf="toggleVehicleDetails">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>vehicles.vehicleInfo</p>
    <div *ngIf="selectedVehicle.vehicleInfo.vinInformations.length">
      <div class="d-flex justify-content-between m-3">
        <span>VIN</span>
        <span>{{selectedVehicle.vehicleInfo.vin}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.manufacturer</span>
        <span style="text-align: right;">{{selectedVehicle.vehicleInfo.vinInformations[0].manufacturer}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.make</span>
        <span>{{selectedVehicle.vehicleInfo.vinInformations[0].make}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.model</span>
        <span>{{selectedVehicle.vehicleInfo.vinInformations[0].model}}</span>
      </div>
      <div class="d-flex justify-content-between m-3">
        <span translate>vehicles.vehicle.year</span>
        <span>{{selectedVehicle.vehicleInfo.vinInformations[0].modelYear}}</span>
      </div>
      <div style="text-align: end;">
        <button style="min-width: 100px;" class="custom-button" (click)="toggleVehicleDetails = false">OK</button>
      </div>
    </div>

    <div *ngIf="!selectedVehicle.vehicleInfo.vinInformations.length">
      <p class="m-5" translate>vehicles.noVinInfo</p>
      <div style="text-align: end;">
        <button style="min-width: 100px;" class="custom-button" (click)="toggleVehicleDetails = false">OK</button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleVehicleSpecifications = false" *ngIf="toggleVehicleSpecifications">
  <div class="modal_container black-text">
    <p class="text-header-modal font-weight-bold" translate>vehicles.vehicle.specifications.title</p>

    <ng-container *ngIf="isLoadingSpecifications; else contentLoaded">
      <div class="d-flex justify-content-center align-items-center" style="height: 300px;">
        <div class="spinner-border text-red" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </ng-container>
    <ng-template #contentLoaded>
      <div *ngIf="vehicleSpecifications">
        <p class="font-weight-bold m-3" translate>vehicles.vehicle.specifications.ownerAndVehicleInformation</p>

        <form #vehicleForm="ngForm" (ngSubmit)="saveSpecifications(vehicleForm)">
          <div *ngFor="let field of mappedVehicleFields; let i = index">
            <div class="d-flex justify-content-between m-3">
              <span>{{ field.label }} <span *ngIf="field.isRequired && isEditMode" style="color: red;">*</span></span>

              <div *ngIf="isEditMode" style="width: 45%;">
                <div *ngIf="field.type === 'text'" class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="field.value" [name]="field.name"
                    [required]="field.isRequired">
                  <span *ngIf="field.unit" class="input-group-text">{{ field.unit }}</span>
                </div>

                <div *ngIf="field.type === 'number' || field.type === 'decimal'" class="input-group">
                  <input type="number" class="form-control" [(ngModel)]="field.value" [name]="field.name"
                    [required]="field.isRequired">
                  <span *ngIf="field.unit" class="input-group-text">{{ field.unit }}</span>
                </div>

                <div *ngIf="field.type === 'date'" class="input-group">
                  <input ngbDatepicker #d="ngbDatepicker" class="form-control" [(ngModel)]="field.value"
                    [name]="field.name" [required]="field.isRequired" />
                  <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>

                <div *ngIf="field.type === 'boolean'" style="margin: 5px 15px 0px 15px;">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" [ngModel]="field.value === true" [value]="true"
                      [name]="field.name" (ngModelChange)="field.value = true" [required]="field.isRequired">
                    <label class="form-check-label" for="inlineRadio1">Yes</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" [ngModel]="field.value === false" [value]="false"
                      [name]="field.name" (ngModelChange)="field.value = false" [required]="field.isRequired">
                    <label class="form-check-label" for="inlineRadio2">No</label>
                  </div>
                </div>
              </div>

              <div *ngIf="!isEditMode">
                <span>{{ field.value }} </span>
                <span *ngIf="field.unit && field.value !== '/'">{{ field.unit }}</span>
              </div>
            </div>
          </div>

          <div class="m-3">
            <p class="font-weight-bold mb-3" translate>vehicles.vehicle.specifications.vehicleEquipment</p>

            <div class="row justify-content-between" *ngIf="!isEditMode && vehicleSpecifications.equipment?.length">
              <span *ngFor="let item of vehicleSpecifications.equipment" class="equipment-item">{{ item.name }}</span>
            </div>

            <p *ngIf="!isEditMode && !vehicleSpecifications.equipment?.length" translate>vehicles.vehicle.specifications.noEquipment</p>

            <div class="row" *ngIf="isEditMode">
              <div class="col-4" *ngFor="let equipment of equipments">
                <label class="custom-checkbox mt-3">
                  <input class="custom-checkbox-input" type="checkbox" [ngModel]="isEquipmentSelected(equipment.id)"
                    [name]="equipment.name" (ngModelChange)="onEquipmentsChange(equipment.id, $event)">
                  <span class="custom-checkbox-text">{{ equipment.translations[0].name }}</span>
                </label>
              </div>
            </div>
          </div>

          <p class="font-weight-bold m-3" translate>vehicles.vehicle.specifications.buyerInformation<span
              *ngIf="requiredFields.includes('description') && isEditMode" style="color: red;">*</span></p>
          <div class="m-3" *ngIf="!isEditMode">
            <span>{{ vehicleSpecifications.description ? vehicleSpecifications.description : '/' }}</span>
          </div>

          <div class="col" *ngIf="isEditMode">
            <textarea type="text" autocomplete="off" class="form-control" id="description" name="description"
              [(ngModel)]="vehicleSpecifications.description" rows="3"
              [required]="requiredFields.includes('description')"></textarea>
          </div>

          <div style="display: flex; text-align: end; justify-content: flex-end; gap: 10px;" class="my-3">

            <button class="btn btn-primary custom-button" type="submit" *ngIf="isEditMode">Save</button>
            <button class="btn btn-outline-info" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">
              Edit
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">
              Cancel
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="toggleVehicleSpecifications = false"
              *ngIf="!isEditMode">Close</button>
          </div>
        </form>
      </div>
    </ng-template>

  </div>
</app-modal>